import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageTitle, Panel, Table, Field, TextInput, Select, Btn, AddButton, RowActions, EmptyState, Modal } from "../components/ui";
import { useI18n } from "../i18n";
import { CL } from "../api";

const TYPES = ["Ofis", "Fabrika", "Depo", "Mağaza", "Veri Merkezi", "Diğer"];
const empty = { name: "", location: "", country: "Türkiye", type: "Ofis", area_m2: "" };

export default function Facilities() {
  const { t } = useI18n();
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const load = () => CL.listFacilities().then(setRows).catch(() => {});
  useEffect(() => { load(); }, []);

  const up = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const openNew = () => { setEditing(null); setForm(empty); setOpen(true); };
  const openEdit = (r) => { setEditing(r); setForm({ ...r, area_m2: r.area_m2 ?? "" }); setOpen(true); };

  const save = async () => {
    if (!form.name.trim()) { toast.error(t("name")); return; }
    const payload = { ...form, area_m2: form.area_m2 === "" ? null : Number(form.area_m2) };
    try {
      if (editing) await CL.updateFacility(editing.id, payload);
      else await CL.createFacility(payload);
      setOpen(false); load(); toast.success(t("saved"));
    } catch { toast.error("Error"); }
  };

  const del = async (r) => {
    if (!window.confirm(t("confirmDelete"))) return;
    await CL.deleteFacility(r.id); load(); toast.success("OK");
  };

  return (
    <div data-testid="facilities-page">
      <PageTitle title={t("facilities")} action={<AddButton label={t("add")} onClick={openNew} />} />
      <Panel>
        {rows.length === 0 ? <EmptyState text={t("noData")} /> : (
          <Table head={[{ label: t("name") }, { label: t("type") }, { label: t("location") }, { label: t("country") }, { label: t("area"), right: true }, { label: t("actions"), right: true }]}>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`facility-row-${r.id}`} className="hover:bg-[#fafbf6]">
                <td className="px-4 py-3 font-medium text-[#1b2420]">{r.name}</td>
                <td className="px-4 py-3 text-[#4b544c]">{r.type}</td>
                <td className="px-4 py-3 text-[#4b544c]">{r.location || "—"}</td>
                <td className="px-4 py-3 text-[#4b544c]">{r.country}</td>
                <td className="px-4 py-3 text-right text-[#4b544c]">{r.area_m2 ?? "—"}</td>
                <td className="px-4 py-3"><RowActions onEdit={() => openEdit(r)} onDelete={() => del(r)} /></td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>

      <Modal open={open} onClose={() => setOpen(false)} title={editing ? t("edit") : t("add")}
        footer={<><Btn variant="outline" onClick={() => setOpen(false)}>{t("cancel")}</Btn><Btn onClick={save} data-testid="facility-save">{t("save")}</Btn></>}>
        <Field label={t("name")}><TextInput data-testid="facility-name" value={form.name} onChange={up("name")} /></Field>
        <div className="grid grid-cols-2 gap-4">
          <Field label={t("type")}><Select data-testid="facility-type" value={form.type} onChange={up("type")}>{TYPES.map((x) => <option key={x}>{x}</option>)}</Select></Field>
          <Field label={t("area")}><TextInput type="number" data-testid="facility-area" value={form.area_m2} onChange={up("area_m2")} /></Field>
        </div>
        <Field label={t("location")}><TextInput data-testid="facility-location" value={form.location} onChange={up("location")} /></Field>
        <Field label={t("country")}><TextInput data-testid="facility-country" value={form.country} onChange={up("country")} /></Field>
      </Modal>
    </div>
  );
}
